module.exports = __webpack_public_path__ + "img/sy4.d467f214.png";